import React, { useContext } from 'react';
import { Props } from '../MonoView';
import EditorDeviationLink from '../_partials/DeviationLink';
import { getSizeForFreeform } from '../helpers';
import TierPromotionCardSemiDumb from '../../../DeviationViews/TierPromotionCardEditorDumb';
import { useEditorContainerSize } from '@wix/da-editor-tiptap/pkg/components/Editor/Context';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { MatureContext } from '@wix/da-react-context/pkg/MatureContext';
import HiddenDumbView from '../../../DeviationViews/Dumbo/Hidden/Hidden';
import { SMALL_MEDIA_WIDTH } from '../constants';

import s from './Tier.scss';

const TierMonoView: React.FC<Props> = props => {
  const containerSize = useEditorContainerSize();
  const showMatureContent = useContext(MatureContext);
  const { isLoggedIn } = useContext(SessionContext);
  const { deviation, extOptions, width: propsWidth, link } = props;

  let size;

  size = { width: 544, height: 295 };

  // Handle resizing
  size = getSizeForFreeform(size, propsWidth);

  // Restrict to small media
  if (extOptions?.smallMedia) {
    size = {
      width: SMALL_MEDIA_WIDTH,
      height: 115,
    };
  }

  // Make sure its never bigger than the container
  if (containerSize && size.width > containerSize) {
    size = getSizeForFreeform(size, containerSize);
  }

  if (
    (!showMatureContent && deviation.isMature) ||
    deviation.isBlocked ||
    (deviation.isAntisocial && !isLoggedIn)
  ) {
    // We have extra check for anti-social because inside a saved editor
    // deviation we can have stale isBlocked value
    return <HiddenDumbView {...props} width={size.width ?? 780} />;
  }

  return (
    <div className={s['root']} style={{ width: size.width }}>
      <EditorDeviationLink link={link} deviation={deviation}>
        <TierPromotionCardSemiDumb
          width={size.width}
          height={size.height}
          deviation={deviation}
          ctaButton="subscribe"
        />
      </EditorDeviationLink>
    </div>
  );
};
TierMonoView.displayName = 'TierMonoView';

export default TierMonoView;
